import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Iconify, Modal, ModalInner } from '@pflegenavi/web-components';
import {
  Alert,
  Button,
  Card,
  IconButton,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import * as React from 'react';

interface ChangeNursingHomeModalProps {
  open: boolean;
  handleClose?: () => void;
  handleConfirm?: () => void;
}

export const ChangeNursingHomeModal: FC<ChangeNursingHomeModalProps> = ({
  open,
  handleClose,
  handleConfirm,
}) => {
  const { t } = useTranslation();

  const onClose = (_: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') {
      if (handleClose) {
        handleClose();
      }
    }
  };

  return (
    <Modal open={open} handleClose={onClose}>
      <ModalInner>
        <ModalCard>
          <Stack
            sx={{
              gap: 3,
              flex: 1,
            }}
          >
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                }}
              >
                {t('sp-web-app.receipt-batch.warn-changing-nursinghome-title')}
              </Typography>
              <IconButton
                onClick={() => {
                  if (handleClose) {
                    handleClose();
                  }
                }}
                sx={{
                  padding: '16px',
                  marginRight: '-8px',
                }}
              >
                <Iconify
                  icon={'eva:close-fill'}
                  sx={{
                    position: 'absolute',
                  }}
                  width={20}
                />
              </IconButton>
            </Stack>
            <Alert severity="warning">
              <Typography variant="body2" sx={{ pt: 0.2 }}>
                {t('sp-web-app.receipt-batch.warn-changing-nursinghome')}
              </Typography>
            </Alert>
            <Stack
              direction="row"
              sx={{
                justifyContent: 'flex-end',
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                color="error"
                onClick={(e) => {
                  e.preventDefault();
                  if (handleClose) {
                    handleClose();
                  }
                }}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  if (handleConfirm) {
                    handleConfirm();
                  }
                }}
              >
                {t('actions.continue')}
              </Button>
            </Stack>
          </Stack>
        </ModalCard>
      </ModalInner>
    </Modal>
  );
};

const ModalCard = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    p: 3,
    width: 600,
    maxWidth: '100%',
    userSelect: 'none',
  })
);
